//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters } from 'vuex';
import Confirm from '../../../../shared-components/vuetify/dialog/Confirm';

export default {
  name: 'TransferenciaPosseForm',
  components: {
    Confirm,
  },
  props: {
    somenteLeitura: true,
  },
  data() {
    return {
      resources: this.$api.transferenciaPosse(this.$resource),
      radioGroup: 'FUNCIONARIO',
      listaDe: [],
      listaPara: [],
      tipo: 'de',
      posse: {
        id: null,
        de: null,
        para: null,
        motivo: '',
        definitiva: false,
      },
      rules: {
        required: value => !!value || this.$t('message.campo_obrigatorio'),
        requiredDe: () => !!(this.posse.de) || this.$t('message.campo_obrigatorio'),
        requiredPara: () => !!(this.posse.para) || this.$t('message.campo_obrigatorio'),
        maxLength50: v => (v && v.length <= 50) || this.$t('message.limite_caracteres_excedido'),
      },
      buscaListaDe: null,
      buscaListaPara: null,
    };
  },
  watch: {
    buscaListaDe(val) {
      if (this.posse.de && this.posse.de.nome === val) return;
      if (this.timeoutDe) {
        window.clearTimeout(this.timeoutDe);
      }
      this.timeoutDe = window.setTimeout(() => {
        if (val) this.buscaListaDePara(val);
      }, 500);
    },
    buscaListaPara(val) {
      if (this.posse.para && this.posse.para.nome === val) return;
      if (this.timeoutPara) {
        window.clearTimeout(this.timeoutPara);
      }
      this.timeoutPara = window.setTimeout(() => {
        if (val && this.posse.de) {
          this.buscaListaDePara(val, 'para', this.posse.de ? this.posse.de.id : null);
        }
      }, 500);
    },
  },
  computed: {
    ...mapGetters('roles', [
      'getAllRoles',
    ]),
    podeTransferenciaDiv() {
      if (!this.getAllRoles) {
        return false;
      }
      return this.getAllRoles.includes('TRANS_POSSE_DIV');
    },
    podeTransferenciaFun() {
      if (!this.getAllRoles) {
        return false;
      }
      return this.getAllRoles.includes('TRANS_POSSE_FUN');
    },
    podeTransferenciaDefinitiva() {
      if (!this.getAllRoles) {
        return false;
      }
      return this.getAllRoles.includes('TRANS_POSSE_DEF');
    },
  },
  methods: {
    abrirDialogSalvar() {
      if (!this.$refs.form.validate()) return;
      this.$refs.confirmDialog.open();
    },
    alterarListas() {
      this.posse.de = null;
      this.posse.para = null;
      this.buscaListaDePara();
    },
    buscarDivisoes(busca = null, tipo = 'de', idNotIn = null) {
      const param = {
        nome: busca,
        tamanhoPagina: 20,
        idNotIn,
      };

      if (tipo === 'para') {
        param.ativo = true;
      }

      this.resources.listarDivisoes(param).then((response) => {
        if (tipo === 'de') {
          this.listaDe = Object.assign([], response.data.resposta);
        } else if (tipo === 'para') {
          this.listaPara = Object.assign([], response.data.resposta);
        }
      }, (err) => {
        this.$error(this, err);
      });
    },
    buscarFuncionarios(busca = null, tipo = 'de', idNotIn = null) {
      const param = {
        nome: busca,
        tamanhoPagina: 20,
        idNotIn,
      };

      if (tipo === 'para') {
        param.ativo = true;
      }

      this.resources.listarFuncionarios(param).then((response) => {
        if (tipo === 'de') {
          this.listaDe = Object.assign([], response.data.resposta);
        } else if (tipo === 'para') {
          this.listaPara = Object.assign([], response.data.resposta);
        }
      }, (err) => {
        this.$error(this, err);
      });
    },
    buscaListaDePara(busca = null, tipo = 'de', idNotIn = null) {
      if (this.radioGroup === 'FUNCIONARIO') this.buscarFuncionarios(busca, tipo, idNotIn);
      else if (this.radioGroup === 'DIVISAO') this.buscarDivisoes(busca, tipo, idNotIn);
    },
    cancelar() {
      this.$refs.form.reset();
      this.$emit('cancelar');
    },
    salvar() {
      const param = {
        motivo: this.posse.motivo,
        definitiva: this.posse.definitiva,
      };

      if (this.radioGroup === 'FUNCIONARIO') {
        param.idFuncionarioOrigem = this.posse && this.posse.de ? this.posse.de.id : null;
        param.idFuncionarioDestino = this.posse && this.posse.para ? this.posse.para.id : null;
      } else if (this.radioGroup === 'DIVISAO') {
        param.idDivisaoOrigem = this.posse && this.posse.de ? this.posse.de.id : null;
        param.idDivisaoDestino = this.posse && this.posse.para ? this.posse.para.id : null;
      }

      this.resources.transferir(param).then(() => {
        this.$toast.create(this.$t('message.adicionado_confira_tabela'), 'snack', '3E3');
        this.$emit('atualizarGrid');
      }, (err) => {
        this.$error(this, err);
      });
    },
    limparPara() {
      this.posse.para = null;
      this.buscaListaDePara(null, 'para', this.posse.de ? this.posse.de.id : null);
    },
    setPara(item) {
      this.posse.para = item;
    },
  },
  beforeMount() {
    if (this.podeTransferenciaDiv && !this.podeTransferenciaFun) {
      this.radioGroup = 'DIVISAO';
    }
  },
};



// WEBPACK FOOTER //
// ./src/custom/abbrasil/spa/transferencia-posse/TransferenciaPosseForm.vue?vue&type=script&lang=js&